import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { createProfile } from '../../actions/profiles';
import {
  updateProfileForm,
  setActiveTab,
  updateTimeSlot,
  removeTimeSlot,
  addTimeSlot,
  reset } from '../../actions/profileForm';

import Window from '../layout/Window';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import ProfileForm from '../forms/Profile';

import './new.scss';

class New extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillUnmount() {
    this.props.resetProfileForm();
  }

  handleSave(e) {
    const { createProfile, profile, match, history } = this.props;
    createProfile(profile)
      .then(d => history.push(`/organisations/${match.params.organisationId}/profiles/${profile.id}${location.search}`))
  }

  render() {
    const {
      t,
      location,
      match,
      posting,
      errors,
      history,
      profile,
      activeTab,
      updateProfileForm,
      onBrightnessTabChange,
      onTimeSlotUpdate,
      onTimeSlotRemove,
      onTimeSlotAdd } = this.props

    return (
      <Window
        onCloseClick={() => history.push(`/organisations/${match.params.organisationId}/profiles${location.search}`)}
        title={t('CREATE_NEW_PROFILE')}
        >
        {posting && <Loading />}
        <ProfileForm
          errors={errors}
          profile={profile}
          onChange={updateProfileForm}
          onTimeSlotUpdate={onTimeSlotUpdate}
          onTimeSlotRemove={onTimeSlotRemove}
          onTimeSlotAdd={onTimeSlotAdd}
          activeBrightnessTab={activeTab}
          onBrightnessTabChange={onBrightnessTabChange} />
          <Button className="save-new-profile" onClick={this.handleSave}>{t('CREATE_PROFILE')}</Button>
      </Window>
    )
  }
}

export default translate('profile')(connect(
  ({ ui }) => ({
    profile: ui.profileForm.profile,
    activeTab: ui.profileForm.activeTab,
    posting: ui.profileForm.posting,
    errors: ui.profileForm.errors
  }),
  (dispatch, { match }) => {
    return {
      updateProfileForm: (e) => dispatch(updateProfileForm(e)),
      resetProfileForm: () => dispatch(reset()),
      createProfile: (profile) => dispatch(createProfile(match.params.organisationId, profile)),
      onBrightnessTabChange: (tab) => dispatch(setActiveTab(tab)),
      onTimeSlotUpdate: (day, time, field, value) => dispatch(updateTimeSlot(day, time, field, value)),
      onTimeSlotRemove: (day, time) => dispatch(removeTimeSlot(day, time)),
      onTimeSlotAdd: (day, time, high, low) => dispatch(addTimeSlot(day, time, high, low))
    }
  }
)(New));



// WEBPACK FOOTER //
// ./src/components/profiles/New.js